module.exports = __webpack_public_path__ + "static/Wynajem-ksero-piotrkow-7ded9c5884b335f122c1e484fd559e05.jpg";